import { styled } from 'styled-components';

export const StyledReleaseNotes = styled.div`
  padding-left: ${({ theme }) => theme.sizing.small};
  position: relative;
  width: 100%;
  color: ${({ theme }) => theme.colours.ink.primary.main};

  &::after {
    content: '';
    position: absolute;
    background-color: ${({ theme }) => theme.colours.layering[3].main};
    border-radius: 50%;
    width: 2rem;
    height: 2rem;
    left: 15.1rem;
    top: 8rem;
  }

  &::before {
    content: '';
    position: absolute;
    background-color: ${({ theme }) => theme.colours.layering[3].main};
    height: calc(100% - 140px);
    width: 2px;
    left: 16rem;
    top: 10rem;
    z-index: 1;
  }

  h1 {
    font-size: ${({ theme }) => theme.typography.headingLarge.fontSize};
    margin-bottom: ${({ theme }) => theme.sizing.medium};
    font-weight: 600;
  }

  h2,
  h3 {
    margin-bottom: ${({ theme }) => theme.sizing.regular};
    ${({ theme }) => theme.typography.headingLarge}
  }

  > div {
    padding: ${({ theme }) => theme.sizing.medium} 4rem;

    > section {
      display: grid;
      grid-template-columns: 100px auto;
      gap: 3.6rem;
      margin-top: ${({ theme }) => theme.sizing.medium};
    }

    section > h2 {
      grid-row-start: 1;
      grid-row-end: 4;
    }

    > section:first-of-type {
      margin-top: 6rem;
    }
  }

  > div:last-child {
    margin-bottom: ${({ theme }) => theme.sizing.medium};
  }

  ul {
    list-style: disc outside;

    li {
      margin-left: ${({ theme }) => theme.sizing.xxlarge};
      position: relative;
      white-space: pre-wrap;
      font-size: ${({ theme }) => theme.typography.headingLarge.fontSize};
    }
  }
`;
